import { Component, computed, input, output } from '@angular/core';
import { Avatar } from 'primeng/avatar';
import { Tooltip } from 'primeng/tooltip';

import { chatCumpleProximo } from '../../../helpers/chat-cumpleanios';
import { capitalizeWords, formatNombreCompletoDisplay } from '../../../helpers/nombre-texto.helper';
import { buildAvatarStyle, buildIniciales } from '../../../helpers/map-congregacion-row';
import { chatNoLeido, chatTipoEntrante } from '../../../helpers/chat-no-leido';
import { chatTienePendiente } from '../../../helpers/chat-tiene-pendiente';
import { ChatConversacion, ChatPerspectiva } from '../../../interfaces/chat.interface';

@Component({
  selector: 'app-chat-list-item',
  standalone: true,
  imports: [Avatar, Tooltip],
  templateUrl: './chat-list-item.component.html',
  styleUrl: './chat-list-item.component.scss',
})
export class ChatListItemComponent {
  readonly conversacion = input.required<ChatConversacion>();
  readonly activo = input(false);
  readonly perspectiva = input<ChatPerspectiva>('admin');
  readonly mostrarNivel = input(false);
  readonly mostrarAvisoDatos = input(false);
  readonly cantCulto = input(1);

  readonly seleccionar = output<void>();

  readonly nombreCompleto = computed(() => {
    const conversacion = this.conversacion();
    return formatNombreCompletoDisplay(conversacion.nombre, '', conversacion.apellido);
  });

  readonly liderLabel = computed(() => capitalizeWords(this.conversacion().miLider));

  readonly iniciales = computed(() =>
    buildIniciales(this.conversacion().nombre, this.conversacion().apellido),
  );

  readonly avatarStyle = computed(() => ({
    ...buildAvatarStyle(this.conversacion().sexo),
    width: '2.5rem',
    height: '2.5rem',
    fontSize: '0.8rem',
  }));

  readonly ultimoMensaje = computed(() => this.conversacion().mensajes.at(-1) ?? null);

  readonly noLeido = computed(() =>
    chatNoLeido(this.conversacion().mensajes, chatTipoEntrante(this.perspectiva())),
  );

  readonly cumpleProximo = computed(() => chatCumpleProximo(this.conversacion().nacimiento));

  readonly tienePendiente = computed(() => chatTienePendiente(this.conversacion()));

  readonly faltaDato = computed(() => {
    if (!this.mostrarAvisoDatos()) {
      return false;
    }
    const conversacion = this.conversacion();
    const sinNacimiento = !conversacion.nacimiento;
    const sinReunion = conversacion.reunionSelect === 0 && this.cantCulto() > 1;
    return sinNacimiento || sinReunion;
  });
}
